var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isChatEnabled && _vm.isChatAllowed)?_c('div',[_c('div',{attrs:{"id":"tdWebchat"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }